import React from "react";
import { useTheme } from "../../context/ThemeContext";
import "./TutorQuestionCard.css";
import { IoSync } from "react-icons/io5";

const TutorQuestionCard = ({ data, onSync, isLoading, questionNumber }) => {
    const { themeStyles } = useTheme();

    // Define styles for the correct answer
    const answerStyle = {
        backgroundColor:
            themeStyles.text === "#FFF" ? "#4CAF50" : "#B4E197", // Dark theme: green, Light theme: pale green
        color: themeStyles.text === "#FFF" ? "#FFF" : "#000",
        fontWeight: "bold",

    };

    return (
        <div
            className="tutor-question-card"
            style={{
                background: themeStyles.cardBackground,
                color: themeStyles.text,
                border: `1px solid ${themeStyles.text}`,
                borderRadius: "8px",
                padding: "16px",
                position: "relative",
                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                overflow: "hidden",
            }}
        >
            {/* Shimmer/Skeleton Loader */}
            {isLoading ? (
                <div
                    className="skeleton-loader"
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                        height: "260px", // Match the card height
                    }}
                >
                    {/* Top shimmer bar for question */}
                    <div
                        className="skeleton-line"
                        style={{

                            width: "100%",
                            height: "20px",
                            borderRadius: "4px",
                        }}
                    ></div>
                    <div
                        className="skeleton-line"
                        style={{

                            width: "100%",
                            height: "20px",
                            borderRadius: "4px",
                        }}
                    ></div>

                    {/* Options shimmer placeholders */}
                    <div
                        className="skeleton-line"
                        style={{
                            marginTop: 25,
                            width: "5%",
                            height: "10px",
                            borderRadius: "4px",
                        }}
                    ></div>
                    <div
                        className="skeleton-line"
                        style={{
                            width: "20%",
                            height: "20px",
                            borderRadius: "4px",
                        }}
                    ></div>
                    <div
                        className="skeleton-line"
                        style={{
                            width: "30%",
                            height: "20px",

                            borderRadius: "4px",
                        }}
                    ></div>
                    <div
                        className="skeleton-line"
                        style={{
                            width: "15%",
                            height: "20px",
                            borderRadius: "4px",
                        }}
                    ></div>
                    <div
                        className="skeleton-line"
                        style={{
                            width: "35%",
                            height: "20px",
                            borderRadius: "4px",
                        }}
                    ></div>
                </div>
            ) : (
                <>
                    {/* Sync Icon */}
                    <IoSync
                        size={30}
                        alt="Sync Icon"
                        className="sync-icon"
                        onClick={onSync}
                        style={{
                            position: "absolute",
                            top: "15px",
                            right: "15px",
                            cursor: "pointer",
                        }}
                    />

                    {/* Question */}
                    <div className="question mr-8" style={{ marginBottom: "16px" }}>
                        <strong>Question {questionNumber}:</strong> {data.question}
                    </div>

                    {/* Options */}
                    <div className="options">
                        <strong>Options:</strong>
                        <ul style={{ listStyleType: "none", paddingLeft: "0" }}>
                            {data.options.map((option, index) => (
                                <li
                                    key={index}
                                    style={{
                                        marginBottom: "8px",
                                        padding: "8px",
                                        border: `1px solid ${themeStyles.text}`,
                                        borderRadius: "4px",
                                        backgroundColor: themeStyles.cardContentBackground,
                                        ...(option === data.answer ? answerStyle : {}), // Apply answer style if it's the correct answer
                                    }}
                                >
                                    {option}
                                </li>
                            ))}
                        </ul>
                    </div>
                </>
            )}
        </div>
    );
};

export default TutorQuestionCard;
